var _path, _path2, _path3, _path4, _path5, _path6, _path7;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCounter(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4372 6.0306C13.8485 6.0306 14.1794 6.36149 14.1794 6.77279C14.1794 7.18408 13.8485 7.51497 13.4372 7.51497H9.23145V17.1634C9.23145 17.5747 8.90055 17.9056 8.48926 17.9056C8.07803 17.9055 7.74707 17.5747 7.74707 17.1634V12.9577H6.75749V17.1634C6.75749 17.5747 6.42659 17.9056 6.0153 17.9056C5.60407 17.9055 5.27311 17.5747 5.27311 17.1634V8.98714L3.9401 11.3431C3.73911 11.7018 3.28808 11.8256 2.92936 11.6247C2.57072 11.4237 2.44697 10.9695 2.64779 10.6139L4.46012 7.41325C4.94255 6.55973 5.8488 6.0306 6.8291 6.0306H13.4372ZM6.8291 7.51497C6.80436 7.51497 6.77913 7.51823 6.75749 7.51823V11.4733H7.74707V7.51497H6.8291Z",
    fill: "#101729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25228 2.07227C7.64592 2.07227 8.02372 2.22851 8.30208 2.50684C8.58046 2.78521 8.73665 3.16296 8.73665 3.55664C8.73665 3.95032 8.58046 4.32807 8.30208 4.60645C8.02372 4.88477 7.64592 5.04102 7.25228 5.04102C6.85865 5.04098 6.48081 4.88478 6.20247 4.60645C5.92415 4.32808 5.7679 3.95029 5.7679 3.55664C5.7679 3.163 5.92415 2.7852 6.20247 2.50684C6.48081 2.2285 6.85865 2.07231 7.25228 2.07227Z",
    fill: "#101729"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 10.0567H11.6273C11.216 10.0567 10.8851 9.72579 10.8851 9.31449C10.8851 8.9032 11.216 8.57231 11.6273 8.57231H14.1663V10.0567Z",
    fill: "#101729"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7054 8.57231C17.1167 8.57231 17.4476 8.9032 17.4476 9.31449C17.4476 9.72579 17.1167 10.0567 16.7054 10.0567H14.1663V8.57231H16.7054Z",
    fill: "#101729"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0439 11.0723C15.4552 11.0723 15.7861 11.404 15.7861 11.8153V16.5728H14.3017V11.8153C14.3017 11.404 14.6326 11.0723 15.0439 11.0723Z",
    fill: "#101729"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7861 16.4424H16.8017V17.9268H15.0439C14.6327 17.9268 14.3019 17.5957 14.3017 17.1846V14.9059H15.7861V16.4424Z",
    fill: "#101729"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6325 16.4424C17.0438 16.4424 17.3747 16.7733 17.3747 17.1846C17.3745 17.5957 17.0437 17.9268 16.6325 17.9268H15.1351V16.4424H16.6325Z",
    fill: "#101729"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter);
export default __webpack_public_path__ + "static/media/counter.3caa94f73fc86dd839cd338ec137bf42.svg";
export { ForwardRef as ReactComponent };